<div style="width: 100%;" [formGroup]="formGroup">
  <div class="row">
    <app-input
      [formGroup]="formGroup"
      controlName="CardNumber"
      label="Card Number"
      hint="XXXX XXXX XXXX XXXX"
      [validationMessages]="validationMessages" [formErrors]="formErrors" >
    </app-input>

    <app-input
      [formGroup]="formGroup"
      controlName="CVV"
      label="CVV"
      hint="123"
      [validationMessages]="validationMessages" [formErrors]="formErrors" >
    </app-input>
  </div>
  <div class="row">
    <app-input
      [formGroup]="formGroup"
      controlName="Expiry"
      label="Expiry"
      hint="(MM/YY) or (MM/YYYY) or (MMYY)"
      [validationMessages]="validationMessages" [formErrors]="formErrors" >
    </app-input>

    <app-input
      [formGroup]="formGroup"
      controlName="CardName"
      label="Name on Card"
      hint="Name on the card"
      [validationMessages]="validationMessages" [formErrors]="formErrors" >
    </app-input>
  </div>
  <div class="row half">
    <app-input
      [formGroup]="formGroup"
      controlName="Currency"
      label="Card Currency"
      inputType="select"
      hint="Select currency"
      [ArrayItems]="['KES', 'USD']"
      [validationMessages]="validationMessages" [formErrors]="formErrors" >
    </app-input>
  </div>
</div>
